import { tv } from 'tailwind-variants'

export const informationList = tv({
  slots: {
    container: 'flex flex-col gap-x-12 gap-y-8 md:flex-row',
    item: ['flex flex-1 flex-col', 'ios:flex-none android:flex-none'],
    titleContainer: 'flex flex-row items-center pb-4',
    title: 'ml-4 flex-shrink',
  },
})
